module.exports = __webpack_public_path__ + "static/media/survey-question-number-icon.1457df60.svg";